import React from 'react'

import { RadioButtonType } from '@lyrahealth-inc/shared-app-logic/src/models/formMetadata/FormMetadata'

import { ClientFiltersSection, ClientFiltersSectionProps } from './ClientFiltersSection'
import { RadioGroup } from '../../../atoms/formElements/RadioButtons'

type Item<T> = {
  id: T
  text: string | React.ReactNode
}

export type ClientFiltersRadioSectionProps<T> = ClientFiltersSectionProps & {
  items: Item<T>[]
  name: string
  value: T
  onChange: (values: T) => void
}

export const ClientFiltersRadioSection = <T extends string>({
  items,
  name,
  value,
  onChange,
  ...props
}: ClientFiltersRadioSectionProps<T>) => {
  return (
    <ClientFiltersSection {...props}>
      <RadioGroup
        buttons={items.map((item) => ({
          label: item.text,
          value: item.id,
        }))}
        selectedValue={value}
        onChange={(newValue) => onChange(newValue as T)}
        name={name}
        baseInputStyle={{ marginBottom: 0 }}
        buttonType={RadioButtonType.DESCRIPTION_NO_OUTLINE}
        buttonStyle={{ marginBottom: 8 }}
      />
    </ClientFiltersSection>
  )
}
